import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import './ProcessNodes.css';

/**
 * Platform Pipeline Node - For Platform knowledge graph queries
 */
function SNNPipelineNode({ data, selected }) {
  const inputCount = data.inputs?.length || 0;
  const outputCount = data.outputs?.length || 0;
  const maxHops = data.snn_config?.max_hops || 3;
  const maxNodes = data.snn_config?.max_nodes || 256;

  const sc = data.snn_config || {};
  const hasRouter = !!sc.router_graph_id;
  const targetLabel = hasRouter
    ? (sc.router_graph_name || sc.router_graph_id?.substring(0, 8) || '')
    : (sc.graph_name || sc.graph_id?.substring(0, 8) || '');

  return (
    <div className={`process-node snn-node ${selected ? 'selected' : ''}`}>
      <Handle
        type="target"
        position={Position.Left}
        className="node-handle input-handle"
      />

      <div className="node-header">
        <span className="node-icon">🧠</span>
        <span className="node-type-badge snn">Platform</span>
      </div>
      
      <div className="node-body">
        <div className="node-name">{data.name || 'Platform Pipeline'}</div>
        {data.description && (
          <div className="node-description">{data.description}</div>
        )}
      </div>

      <div className="node-footer">
        {targetLabel ? (
          <div className="node-target-info">
            <span className={`target-pill ${hasRouter ? 'target-router' : 'target-graph'}`}>
              {hasRouter ? 'Router' : 'Graph'}
            </span>
            <span className="target-name" title={hasRouter ? sc.router_graph_id : sc.graph_id}>
              {targetLabel}
            </span>
          </div>
        ) : (
          <div className="node-meta">
            <span className="meta-item">
              <span className="meta-icon">↓</span>
              {inputCount} in
            </span>
            <span className="meta-item">
              <span className="meta-icon">↑</span>
              {outputCount} out
            </span>
          </div>
        )}
        <div className="node-config">
          <span title="Max hops">H:{maxHops}</span>
          <span title="Max nodes">N:{maxNodes}</span>
          {data.knowledgeLinkCount > 0 && (
            <span className="knowledge-link-badge" title="Knowledge graph links">
              🔗 {data.knowledgeLinkCount}
            </span>
          )}
        </div>
      </div>

      {/* Output Handle */}
      <Handle
        type="source"
        position={Position.Right}
        className="node-handle output-handle"
      />
    </div>
  );
}

export default memo(SNNPipelineNode);
